import { forwardRef } from 'react';
import { cx } from 'class-variance-authority';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';

import * as styles from './styles';
import { RootStyleProps } from './styles';

type CardRootTypeMap = BaseTypeMap<'div', RootStyleProps & {}>;

export type CardRootProps = ComponentProps<CardRootTypeMap>;

export const CardRoot: Component<CardRootTypeMap> = forwardRef(
  function CardRoot(
    { children, className, color, shadow = true, rounded = true, ...rest },
    ref
  ) {
    return (
      <Box
        className={cx(styles.root({ shadow, rounded }), className)}
        ref={ref}
        {...rest}
      >
        {children}
      </Box>
    );
  }
);
